// extracted by mini-css-extract-plugin
export var markdown = "_t2-0";
export var tableWrapper = "_t2-1";